
<template>
	<page>
		<module>
			<view-list
				ref="view"
				work-type="13"
				selector
                tab-hidden
			>
				<template #search>
					<m-search ref="search">
						<m-search-item label="背贴码">
							<m-code-batch-input name="produce_codes" field-name="背贴码" placeholder="请输入背贴码，支持批量"></m-code-batch-input>
						</m-search-item>
						<m-search-item label="IMEI">
							<m-code-batch-input name="imeis" field-name="IMEI" placeholder="请输入IMEI，支持批量"></m-code-batch-input>
						</m-search-item>
						<m-search-item label="订单号">
							<c-input name="keyword" placeholder="销售单号"></c-input>
						</m-search-item>
						<m-search-item label="产品信息">
							<c-input name="product_info" placeholder="产品名称/背贴码/IMEI"></c-input>
						</m-search-item>
						<m-search-item label="客户">
							<c-select name="customer_id" async @search="searchCustomer"></c-select>
						</m-search-item>
						<m-search-item label="售卖类型">
							<c-select name="sell_type" :options="sellTypeOptions"></c-select>
						</m-search-item>
						<m-search-item label="创建时间" colspan="2">
							<c-datetime range start-name="start_date" end-name="end_date"></c-datetime>
						</m-search-item>
					</m-search>
				</template>

				<template #operate>
					<c-button v-if="auth('b_offline_order_create')" color="main" prepend-icon="tf-add" @click="createOrder()">新建售出订单</c-button>
					<c-button v-if="auth('b_offline_order_collect_payment')" color="main" prepend-icon="tf-batch" @click="collectPayment()">批量收款</c-button>
				</template>

				<template #batchOperate="{data}">
					<c-button v-if="auth('b_offline_order_collect_payment')" color="main" prepend-icon="tf-batch" @click="collectPayment(data)">批量收款</c-button>
				</template>

				<template #refund_info="{data}">
					<span v-if="!Number(data.refund_amount)">-</span>
					<div v-else class="m-product-info">
						<p style="color: #e53e3e;">{{formatPrice(data.refund_amount)}}</p>
						<p class="m-product-info-code">{{data.refund_date || '-'}}</p>
					</div>
				</template>

				<template #product_info="{data}">
					<m-product-info :name="data.product_name || getProductText(data)" :level="data.level_type" :code="data.produce_code" :imei="data.imei"></m-product-info>
				</template>

                <template #level_type="{data}">
                    <c-state tag async dict="LEVEL_TYPE" :value="data.level_type"></c-state>
                </template>

				<template #cost_price="{data}">
					{{formatPrice(data.cost_price)}}
				</template>

				<template #produce_code="{data}">
					{{data.produce_code}} <c-link color="gray" @click="$copy(data.produce_code)"><i class="tf">&#xe6b0;</i></c-link>
				</template>

				<template #produce_imei="{data}">
					{{data.produce_imei}} <c-link v-if="data.produce_imei" color="gray" @click="$copy(data.produce_imei)"><i class="tf">&#xe6b0;</i></c-link>
				</template>

				<template #sale_price="{data}">
					<span style="color: #e53e3e;">{{formatPrice(data.sale_price)}}</span>
				</template>

				<template #receiver_info="{data}">
					<div class="m-product-info">
						<p v-if="data.receiver_name">{{data.receiver_name}}　{{data.receiver_phone}}</p>
						<p v-if="data.receiver_address" class="m-product-info-code">{{data.receiver_address}}</p>
						<p v-if="!data.receiver_name && !data.receiver_address">-</p>
					</div>
				</template>

				<template #sell_type="{data}">
					<c-state async dict="SALE_SELL_TYPE" tag :value="data.sell_type"></c-state>
				</template>

				<template #order_state="{data}">
					<c-state async dict="SALES_ORDER_STATE" tag :value="getOrderDisplayState(data)"></c-state>
				</template>

				<template #create_user_id="{data}">
					{{data.create_user_realname || '-'}}
				</template>

				<c-table-column
					type="button"
					label="操作"
					width="160"
					button-limit="6"
				>
					<template #default="{data}">
                        <c-table-button v-if="auth('b_offline_order_query')" icon="tf-detail" @click="viewDetail(data)">详情</c-table-button>
                        <c-table-button v-if="auth('b_offline_order_edit') && data.order_state == 1" icon="tf-edit" @click="editOrder(data)">编辑</c-table-button>
						<c-table-button v-if="auth('b_offline_order_collect_payment') && data.order_state == 1" icon="tf-settle-account" @click="collectPayment(data)">收款</c-table-button>
                        <c-table-button v-if="auth('b_offline_order_print')" icon="tf-print" @click="batchPrintByTemplate(data)">打印</c-table-button>
						<c-table-button v-if="auth('b_offline_order_ship') && data.order_state == 2"  icon="tf-deliver" @click="shipOrder(data)">发货</c-table-button>
						<c-table-button v-if="auth('b_offline_order_apply_after_sale') && data.order_state == 4 && data.is_after_saleable==1" icon="tf-return-goods" @click="applyAfterSale(data)">申请售后</c-table-button>
                        <c-table-button v-if="auth('b_offline_order_cancel') && data.order_state == 1" icon="tf-cancel" @click="cancelOrder(data)">取消订单</c-table-button>
					</template>
				</c-table-column>
			</view-list>
		</module>
	</page>
</template>

<script>
	export default {
		data() {
			return {
				sellTypeOptions: [{
					name: '整机',
					value: 1
				}, {
					name: '拆机',
					value: 2
				}]
			}
		},

		methods: {
			/*********线下统一显示状态：售后优先，业务操作仍使用 order_state**********/
			getOrderDisplayState(data) {
				const displayState = Number(data.display_state);
				if ([1, 2, 3, 4, 5, 9, 10, 11].includes(displayState)) {
					return displayState;
				}
				return data.order_state;
			},

			/*********搜索客户**********/
			searchCustomer(keyword, resolve) {
				this.request({
					url: '/sale/customer/options',
					data: {
						keyword: keyword
					},
					success: data => {
						resolve((data || []).map(item => {
							return {
								name: item.customer_name,
								value: item.id
							};
						}));
					}
				});
			},

			/*********格式化价格**********/
			formatPrice(price) {
				if (price === null || price === undefined || price === '') return '-';
				return '¥' + parseFloat(price).toFixed(2);
			},

			/*********获取产品信息文字**********/
			getProductText(data) {
				var parts = [];
				if (data.brand_name) parts.push(data.brand_name);
				if (data.model_name) parts.push(data.model_name);
				if (data.memory_name) parts.push(data.memory_name);
				if (data.color_name) parts.push(data.color_name);
				return parts.join(' ') || '-';
			},

			/*********新建售出订单**********/
			createOrder() {
				this.globalDialog('offlineOrderEdit', {}, () => {
					this.$refs.view.update();
				});
			},

			/*********编辑订单**********/
			editOrder(data) {
				this.globalDialog('offlineOrderEdit', {
					data: {
						orderId: data.order_id,
                        orderNo: data.order_no
					}
				}, () => {
					this.$refs.view.update();
				});
			},

			/*********收款（单个/批量）**********/
			collectPayment(selectedRows) {
				var rows = [];
				if (selectedRows && selectedRows.order_id) {
					// 单个订单收款
					rows = [selectedRows];
				} else {
					// 批量收款：获取选中的行（参照线上订单批量生成发货单写法）
					rows = (selectedRows || []).map(item => item.data || item);
					if (!rows.length) {
						var listRef = this.$refs.view && this.$refs.view.$refs.list;
						rows = (listRef && listRef.getRow('selected') || []).map(item => item.data || item);
					}
				}

				if (!rows.length) {
					this.$message({message: '请先选择订单', type: 'warn'});
					return;
				}

				// 仅待付款订单可收款
				rows = rows.filter(item => item.order_state == 1);
				if (!rows.length) {
					this.$message({message: '仅待付款状态的订单可收款', type: 'warn'});
					return;
				}

				var orderIds = rows.map(item => item.order_id);
				this.globalDialog('salePayDialog', {
					data: {
						orderIds: orderIds
					}
				}, () => {
					this.$refs.view.update();
				});
			},

			/*********发货（当面交接/邮寄发货，发货后订单完成）**********/
			shipOrder(data) {
				this.globalDialog('offlineShipDialog', {
					data: {
						orderId: data.order_id,
						orderNo: data.order_no || '',
						productName: data.product_name || this.getProductText(data),
						produceCode: data.produce_code || '',
						receiverName: data.receiver_name || '',
						receiverPhone: data.receiver_phone || '',
						receiverAddress: data.receiver_address || ''
					}
				}, () => {
					this.$refs.view.update();
				});
			},

			/*********申请售后（按当前商品明细申请）**********/
			applyAfterSale(data) {
				this.globalDialog('saleAfterApply', {
					data: {
						orderId: data.order_id,
						orderProductId: data.id,
						product: data
					}
				}, () => {
					this.$refs.view.update();
				});
			},

			/*********打印（单个/批量，按订单打印售出单）**********/
			batchPrintByTemplate(data) {
				var ids = [];
				if (data && data.order_id) {
					// 单个订单打印
					ids.push(data.order_id);
				} else {
					// 批量打印：获取选中行的订单ID
					this.$refs.view.$refs.list.getData('selected').forEach(item => {
						ids.push(item.order_id);
					});
				}
				if (!ids.length) {
					this.$message({type: 'warn', message: '请选择需要打印的订单'});
					return;
				}
				this.$refs.view.batchPrintByTemplate(ids);
			},

			/*********查看详情**********/
			viewDetail(data) {
				this.globalDialog('saleOrderDetail', {
					props: {
						orderType: 1
					},
					data: {
						orderId: data.order_id
					}
				}, () => {
					this.$refs.view.update();
				});
			},

			/*********取消订单**********/
			cancelOrder(data) {
				this.$confirm({
					message: '确认取消订单【' + data.order_no + '】吗？取消后商品将恢复为可售状态',
					buttonName: '确定',
					cancelButton: true,
					resolve: () => {
						this.request({
							url: '/offline/sale/order/cancel',
							data: {
								order_id: data.order_id,
								cancel_reason: '手动取消'
							},
							loading: true,
							success: (data, msg) => {
								this.$message({message: msg || '取消成功', type: 'success'});
								this.$refs.view.update();
							}
						});
					}
				});
			},

			/*********加载系统业务日志列表**********/
			loadWorkLogDetail() {
				this.globalDialog('workLogDetail', {
					props: {
						workType: 13
					}
				});
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.m-product-info {
		line-height: 24px;
		font-size: 13px;
		color: #333;

		.m-product-info-name {
			display: flex;
			align-items: center;
			gap: 4px;
		}

		.m-product-info-code {
			color: #999;
			font-size: 12px;
		}
	}
</style>
